import type { CSSProperties } from "react";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import styles from "./index.module.scss";

type InfoItem = {
	title?: string;
	text?: string;
	textAlignment?: string | null;
	image?: {
		url?: string;
		alt?: string | null;
		format?: string;
	};
};

type LimitedEditionInfoCardProps = {
	item: InfoItem;
	textColor?: { hex?: string; cssRgb?: string };
	iconColor?: { hex?: string };
	cardBgColor?: string;
};

function mapAlign(textAlignment?: string | null): "center" | "left" | "right" {
	const normalized = textAlignment?.toLowerCase() ?? "center";
	if (normalized === "left") return "left";
	if (normalized === "right") return "right";
	return "center";
}

export function LimitedEditionInfoCard({
	item,
	textColor,
	iconColor,
	cardBgColor,
}: LimitedEditionInfoCardProps) {
	const align = mapAlign(item.textAlignment);
	const iconStyle = iconColor?.hex
		? ({
				backgroundColor: iconColor.hex,
				WebkitMaskImage: `url(${item.image?.url})`,
				maskImage: `url(${item.image?.url})`,
			} as CSSProperties)
		: undefined;

	return (
		<article
			className={styles.infoCard}
			style={cardBgColor ? { backgroundColor: cardBgColor } : undefined}
		>
			{item.image?.url && (
				<span
					className={styles.infoIcon}
					style={iconStyle}
					role="img"
					aria-label={item.image.alt ?? item.title ?? ""}
				/>
			)}
			{item.title && (
				<MultiPurposeParagraph
					type="limitedEditionInfoTitle"
					align="center"
					data={item.title}
					color={textColor}
				/>
			)}
			{item.text && (
				<MultiPurposeParagraph
					type="label"
					align={align}
					data={item.text}
					color={textColor}
				/>
			)}
		</article>
	);
}
